"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FTXFeedHandler = void 0;
const L2Book_1 = require("../L2Book");
const Feedhandler_1 = require("./Feedhandler");
class FTXFeedHandler extends Feedhandler_1.FeedHandler {
    constructor() {
        super('FTX', 'wss://ftx.com/ws/');
    }
    onOpen(event) {
        this.ws().send(JSON.stringify({
            op: 'subscribe',
            channel: 'orderbook',
            market: this.getSymbol()
        }));
        this.ws().send(JSON.stringify({
            op: 'subscribe',
            channel: 'trades',
            market: this.getSymbol()
        }));
    }
    onMessage(event) {
        const data = JSON.parse(event.data.toString());
        if (data.channel === 'orderbook') {
            return this.handleOrderBookEvent(data);
        }
        if (data.channel === 'trades') {
            return this.handleTradeEvent(data);
        }
    }
    handleOrderBookEvent(data) {
        const typ = data.type;
        if (!['partial', 'update'].includes(typ))
            return;
        const event = {
            action: typ === 'partial' ? L2Book_1.OrderBookAction.Partial : L2Book_1.OrderBookAction.Update,
            bids: data.data.bids,
            asks: data.data.asks
        };
        this.publishOrderBookEvent(event);
    }
    handleTradeEvent(data) {
        if (data.type !== 'update')
            return;
        const trades = data.data.forEach((t) => {
            const trade = {
                price: t.price,
                size: t.size,
                side: t.side === 'buy' ? L2Book_1.Side.Buy : L2Book_1.Side.Sell
            };
            this.publishTradeEvent(trade);
        });
    }
}
exports.FTXFeedHandler = FTXFeedHandler;
